import * as firebase from 'firebase';

const config = {
  // apiKey: "AIzaSyDkI88PI4XTPmDZqh0xkmsEhLy6IJuP2PI",
  // authDomain: "devio-230804.firebaseapp.com",
  // databaseURL: "https://devio-230804.firebaseio.com",
  // projectId: "devio-230804",
  // storageBucket: "devio-230804.appspot.com",
  // messagingSenderId: "765936737061",
  // appId: "1:765936737061:web:ee59f1fb52edcb3c1858cc",
  // measurementId: "G-LFFKXR7YH1"
  apiKey: "AIzaSyB5rnBWs-naWpceuZKjLYxlr6wykfCzFPY",
  authDomain: "tdg-dh-fortune-teller-nonprod.firebaseapp.com",
  databaseURL: process.env.VUE_APP_DATABASE_URL,//"https://tdg-dh-fortune-teller-nonprod-preprod.asia-southeast1.firebasedatabase.app",
  projectId: "tdg-dh-fortune-teller-nonprod",
  storageBucket: "tdg-dh-fortune-teller-nonprod.appspot.com",
  messagingSenderId: "751976824560",
  appId: "1:751976824560:web:1f6c1a1656f6c8badb0c35",
  measurementId: "G-M1B54W514Y"
};

firebase.initializeApp(config);

export default firebase;